import api from './axiosInstance';

/**
 * Escrituras asignadas al usuario logueado (vista global "Mis escrituras").
 *
 * Backend: EscriturasIntakeController (GET /escrituras/assigned). El validador
 * (abogado EEPP) lo resuelve el server desde el token — no se pasa por query/body.
 * Devuelve una fila por escritura asignada, a través de todos los casos, excluyendo
 * las canceladas; activas primero, luego por fecha de creación descendente.
 *
 * Forma del DTO (AssignedWritingDto):
 *   { escrituraId, caseId, clientId, clientName, writingTypeCode,
 *     writingTypeDisplayName, estado, createdAt,
 *     slaDueAt, slaStatus, slaDaysLeft, flowStage }
 *
 * Campos SLA (todos pueden venir null en escrituras pre-deploy sin reloj):
 *   - slaDueAt: fecha límite ISO (creación + Tiempos días hábiles) | null
 *   - slaStatus: "pending" | "due" | "closed" | null
 *   - slaDaysLeft: días hábiles restantes (negativo = vencido) | null
 *   - flowStage: etapa del flujo — "recoleccion" | "redaccion" | "validacion" |
 *     "notaria" | "finalizada" | "cancelada"
 *
 * clientId (Cases_SAAS.ClientId) es la id que usa la ruta del detalle de cliente; la
 * vista la usa para enlazar a /crm/detalles-cliente/{clientId}. Puede ser null si el
 * caso es huérfano (sin fila de caso) — la UI cae a no-enlazar la fila.
 */
export const getAssignedWritings = async (signal) => {
  const response = await api.get('/escrituras/assigned', { signal });
  return response.data || [];
};
